import { ViewportState } from '@/interfaces/ViewportState'

export const setWidth = (state: ViewportState, width: number): void => {
	state.width = width
}
